<template>
  <component
      class="io-headline"
      :is="tag"
      :class="classes"
      :style="style"
  >
    <slot></slot>
  </component>
</template>

<script lang="ts" setup>
import {
  computed, inject,
} from 'vue';

const props = defineProps({
  textAlign: {
    type: String,
    default: 'center',
  },
  size: {
    type: String,
    default: 'h5',
  },
  tagName: {
    type: String,
    default: 'inherit',
  },
  className: {
    type: String,
    default: null,
  },
  color: {
    type: String,
    default: 'dark',
  },
  colorLg: {
    type: String,
    default: 'inherit',
  },
  bold: {
    type: Boolean,
    default: false,
  },
});

const alignment = inject<string>('cardItemsAlign', props.textAlign);

const tag = computed(() => (props.tagName !== 'inherit' ? props.tagName : props.size));

const classes = computed(() => {
  const headlineClasses = [];

  headlineClasses.push(`color-${props.color}`);

  if (props.colorLg !== 'inherit') {
    headlineClasses.push(`color-lg-${props.colorLg}`);
  }

  if (props.size !== tag.value) {
    headlineClasses.push(props.size);
  }

  if (props.bold) {
    headlineClasses.push('bold');
  }

  return headlineClasses;
});

const style = computed(() => {
  const styles = {} as Record<string, string>;

  if (alignment !== 'inherit') {
    styles['--base-text-align'] = alignment;
  }

  return styles;
});

</script>

<style lang="scss">
@import "src/scss/component-helpers";

.io-headline {
  position: relative;
  z-index: 2;
  display: block;
  margin: 0;
  text-align: var(--base-text-align);
}
</style>
